import moment from "moment";
import LcIcon from "../../components/Generic/LcIcon";
import LcTooltip from "../../components/Generic/LcTooltip";
import RequesterDisplay from "../../components/Generic/RequesterDisplay";
import StatusColorDisplay from "../../components/Generic/StatusColorDisplay";
import { SolicitationView } from "../../models/SolicitationView";
import AttendanceSlaSloBar from "../../pages/Attendance/AttendanceSlaSloBar";
import SolicitationService from '../SolicitationService/SolicitationService';

export interface Column {
    checkbox: boolean,
    id: boolean,
    idStatus: boolean,
    workStatus: boolean,
    sla_slo: boolean,
    subject: boolean,
    workName: boolean,
    workGroupName: boolean,
    nameResponsibleUser: boolean,
    nameUserRequester: boolean,
    registrationDate: boolean,
    nameCustomer: boolean,
    nameBusinessArea: boolean,
    nameClassification: boolean,
    statusIcon: boolean,
    endDate: boolean,
    nameClassificationGroup: boolean,
    nameServiceGroup: boolean,
    nameOpenMode: boolean,
    urgency: boolean,
    nameProcess: boolean,
    nameService: boolean,
    slaResponseDate: boolean,
    slaSolutionDate: boolean,
    workType: boolean,
    businessUnitDescription: boolean,
    slaDescription: boolean,
    workDateBegin: boolean,
    workDateEnd: boolean,
    workDateRegister: boolean,
    lastCommentDate: boolean,
};

export interface Group {
    ungrouped: boolean,
    id: boolean,
    idStatus: boolean,
    workStatus: boolean,
    sla_slo: boolean,
    subject: boolean,
    workName: boolean,
    workGroupName: boolean,
    nameResponsibleUser: boolean,
    nameUserRequester: boolean,
    registrationDate: boolean,
    nameCustomer: boolean,
    nameBusinessArea: boolean,
    nameClassification: boolean,
    statusIcon: boolean,
    endDate: boolean,
    nameClassificationGroup: boolean,
    nameServiceGroup: boolean,
    nameOpenMode: boolean,
    urgency: boolean,
    nameProcess: boolean,
    nameService: boolean,
    slaResponseDate: boolean,
    slaSolutionDate: boolean,
    workType: boolean,
    businessUnitDescription: boolean,
    slaDescription: boolean,
    workDateBegin: boolean,
    workDateEnd: boolean,
    workDateRegister: boolean,
    lastCommentDate: boolean,
};

export default class DynamicTableGroupAndColumnBuilder {

    public columnsSize = {
        checkbox: "50px",
        nameBusinessArea: "200px",
        subject: "400px",
        workName: "400px",
        nameResponsibleUser: "162px",
        nameClassification: "200px",
        workStatus: "215px",
        idStatus: "215px",
        statusIcon: "50px",
        registrationDate: "108px",
        endDate: "150px",
        nameCustomer: "264px",
        workGroupName: "220px",
        nameClassificationGroup: "250px",
        nameServiceGroup: "300px",
        nameOpenMode: "150px",
        nameProcess: "400px",
        nameService: "400px",
        slaResponseDate: "150px",
        slaSolutionDate: "150px",
        sla_slo: "130px",
        id: "85px",
        nameUserRequester: "240px",
        workType: "300px",
        businessUnitDescription: "300px",
        slaDescription: "200px",
        workDateBegin: "158px",
        workDateEnd: "158px",
        workDateRegister: "158px",
        lastCommentDate: "180px",
    }

    public optionColumnsDefault: Column = {
        checkbox: true,
        id: true,
        idStatus: true,
        workStatus: false,
        sla_slo: true,
        subject: true,
        workName: false,
        workGroupName: true,
        nameResponsibleUser: true,
        nameUserRequester: true,
        registrationDate: true,
        nameCustomer: true,
        nameBusinessArea: false,
        nameClassification: false,
        statusIcon: false,
        endDate: false,
        nameClassificationGroup: false,
        nameServiceGroup: false,
        nameOpenMode: false,
        urgency: true,
        nameProcess: false,
        nameService: false,
        slaResponseDate: false,
        slaSolutionDate: false,
        workType: false,
        businessUnitDescription: false,
        slaDescription: false,
        workDateBegin: false,
        workDateEnd: false,
        workDateRegister: false,
        lastCommentDate: false,
    };

    public openGroupDefault: Group = {
        ungrouped: true,
        id: false,
        idStatus: false,
        workStatus: false,
        sla_slo: false,
        subject: false,
        workName: false,
        workGroupName: false,
        nameResponsibleUser: false,
        nameUserRequester: false,
        registrationDate: false,
        nameCustomer: false,
        nameBusinessArea: false,
        nameClassification: false,
        statusIcon: false,
        endDate: false,
        nameClassificationGroup: false,
        nameServiceGroup: false,
        nameOpenMode: false,
        urgency: false,
        nameProcess: false,
        nameService: false,
        slaResponseDate: false,
        slaSolutionDate: false,
        workType: false,
        businessUnitDescription: false,
        slaDescription: false,
        workDateBegin: false,
        workDateEnd: false,
        workDateRegister: false,
        lastCommentDate: false,
    };

    public groupList = [
        {
            label: "(Sem agrupamento)",
            value: "ungrouped"
        },
        {
            label: "Urgência (Cor)",
            value: "urgency"
        },
        {
            label: "N° Sol.",
            value: "id"
        },
        {
            label: "Status Solicitação",
            value: "idStatus"
        },
        {
            label: "SLA / SLO",
            value: "sla_slo"
        },
        {
            label: "Assunto da Solicitação",
            value: "subject"
        },
        {
            label: "Equipe de Trabalho",
            value: "workGroupName"
        },
        {
            label: "Atendente",
            value: "nameResponsibleUser"
        },
        {
            label: "Solicitante",
            value: "nameUserRequester"
        },
        {
            label: "Data Sol.",
            value: "registrationDate"
        },
        {
            label: "Cliente",
            value: "nameCustomer"
        }
    ];

    public columnList = [
        {
            label: "Urgência (Cor)",
            value: "urgency"
        },
        {
            label: "N° Sol.",
            value: "id"
        },
        {
            label: "Status Solicitação",
            value: "idStatus"
        },
        {
            label: "SLA / SLO",
            value: "sla_slo"
        },
        {
            label: "Assunto da Solicitação",
            value: "subject"
        },
        {
            label: "Equipe de Trabalho",
            value: "workGroupName"
        },
        {
            label: "Atendente",
            value: "nameResponsibleUser"
        },
        {
            label: "Solicitante",
            value: "nameUserRequester"
        },
        {
            label: "Data Sol.",
            value: "registrationDate"
        },
        {
            label: "Cliente",
            value: "nameCustomer"
        }
    ];

    public densityList = [
        {
            label: "Baixa",
            value: "lowdensity"
        },
        {
            label: "Normal (Padrão)",
            value: "defaultdensity"
        },
        {
            label: "Alta",
            value: "highdensity"
        },
    ];

    getColumnsList() {
        const colunas = [
            // {
            //     label: "",
            //     value: "checkbox"
            // },
            {
                label: "Ícone Status Sol.",
                value: "statusIcon"
            },
            {
                label: "N° Sol.",
                value: "id"
            },
            {
                label: "Status Trabalho",
                value: "workStatus"
            },
            {
                label: "Status Solicitação",
                value: "idStatus"
            },
            {
                label: "SLA / SLO",
                value: "sla_slo"
            },
            {
                label: "Assunto da Solicitação",
                value: "subject"
            },
            {
                label: "Assunto do Trabalho",
                value: "workName"
            },
            {
                label: "Equipe de Trabalho",
                value: "workGroupName"
            },
            {
                label: "Atendente",
                value: "nameResponsibleUser"
            },
            {
                label: "Solicitante",
                value: "nameUserRequester"
            },
            {
                label: "Data Sol.",
                value: "registrationDate"
            },
            {
                label: "Cliente",
                value: "nameCustomer"
            },
            {
                label: "Classificação",
                value: "nameClassification"
            },

            {
                label: "Data Início Trab.",
                value: "workDateBegin"
            },
            {
                label: "Data Registro Trab.",
                value: "workDateRegister"
            },

            {
                label: "Data Término Sol.",
                value: "endDate"
            },
            {
                label: "Data Término Trab.",
                value: "workDateEnd"
            },
            {
                label: "Grupo de Classificação",
                value: "nameClassificationGroup"
            },
            {
                label: "Grupo de Serviço",
                value: "nameServiceGroup"
            },
            {
                label: "Modo Abertura",
                value: "nameOpenMode"
            },
            {
                label: "Urgência (Cor)",
                value: "urgency"
            },
            {
                label: "Processo",
                value: "nameProcess"
            },
            {
                label: "Serviço",
                value: "nameService"
            },
            {
                label: "SLA Data Resposta",
                value: "slaResponseDate"
            },
            {
                label: "SLA Data Solução",
                value: "slaSolutionDate"
            },
            {
                label: "Tipo de Trabalho",
                value: "workType"
            },
            {
                label: "SLA Descrição",
                value: "slaDescription"
            },
            {
                label: "Unidade de Negócio",
                value: "businessUnitDescription"
            },
            // {
            //     label: "Data Últ. Comentário",
            //     value: "lastCommentDate"
            // },
        ];

        return colunas;
    }

    getAllAvaliableColumns() {
        const colunas = [
            // {
            //     field: 'checkbox',
            //     headerName: "",
            //     hide: true,
            //     width: this.columnsSize["checkbox"]
            // },
            {
                field: 'statusIcon',
                headerName: 'Ícone de Status de Solicitação',
                hide: true,
                width: this.columnsSize["statusIcon"],
                height: '35px',
                // overflow: "visible"
            },
            {
                field: 'id',
                headerName: 'N° Sol.',
                hide: true,
                width: this.columnsSize["id"],
            },
            {
                field: 'idStatus',
                headerName: 'Status Solicitação ',
                hide: true,
                width: this.columnsSize["idStatus"],
            },
            {
                field: 'workStatus',
                headerName: 'Status Trabalho',
                hide: true,
                width: this.columnsSize["workStatus"],
            },
            {
                field: 'sla_slo',
                headerName: 'SLA / SLO',
                hide: true,
                width: this.columnsSize["sla_slo"],
            },
            {
                field: "subject",
                headerName: 'Assunto da Solicitação',
                hide: true,
                width: this.columnsSize["subject"],
                class: 'subject'

            },
            {
                field: 'workName',
                headerName: 'Assunto do Trabalho',
                hide: true,
                width: this.columnsSize["workName"],
            },
            {
                field: "workGroupName",
                headerName: 'Equipe de Trabalho',
                hide: true,
                width: this.columnsSize["workGroupName"],
            },
            {
                field: "nameResponsibleUser",
                headerName: 'Atendente',
                hide: true,
                width: this.columnsSize["nameResponsibleUser"],
            },
            {
                field: 'nameUserRequester',
                headerName: 'Solicitante',
                hide: true,
                width: this.columnsSize["nameUserRequester"],
                class: 'requester'
            },
            {
                field: 'registrationDate',
                headerName: 'Data Sol.',
                hide: true,
                width: this.columnsSize["registrationDate"],
            },
            {
                field: 'nameCustomer',
                headerName: 'Cliente',
                hide: true,
                width: this.columnsSize["nameCustomer"],
                class: 'nameCustomer'

            },
            {
                field: "nameBusinessArea",
                headerName: 'Área de Negócio',
                hide: true,
                width: this.columnsSize["nameBusinessArea"],
            },
            {
                field: 'nameClassification',
                headerName: 'Classificação',
                hide: true,
                width: this.columnsSize["nameClassification"],
            },
            {
                field: 'workDateBegin',
                headerName: 'Data Início Trab.',
                hide: true,
                width: this.columnsSize["workDateBegin"],
            },
            {
                field: 'workDateRegister',
                headerName: 'Data Registro Trab.',
                hide: true,
                width: this.columnsSize["workDateRegister"],
            },
            {
                field: 'endDate',
                headerName: 'Data Término Sol.',
                hide: true,
                width: this.columnsSize["endDate"],
            },
            {
                field: 'workDateEnd',
                headerName: 'Data Término Trab.',
                hide: true,
                width: this.columnsSize["workDateEnd"],
            },
            {
                field: 'nameClassificationGroup',
                headerName: 'Grupo de Classificação',
                hide: true,
                width: this.columnsSize["nameClassificationGroup"],
            },
            {
                field: 'nameServiceGroup',
                headerName: 'Grupo de Serviço',
                hide: true,
                width: this.columnsSize["nameServiceGroup"],
            },
            {
                field: 'nameOpenMode',
                headerName: 'Modo Abertura',
                hide: true,
                width: this.columnsSize["nameOpenMode"],
            },
            {
                field: 'nameProcess',
                headerName: 'Processo',
                hide: true,
                width: this.columnsSize["nameProcess"],
            },
            {
                field: 'nameService',
                headerName: 'Serviço',
                hide: true,
                width: this.columnsSize["nameService"],
            },
            {
                field: 'slaResponseDate',
                headerName: 'SLA Data Resposta',
                hide: true,
                width: this.columnsSize["slaResponseDate"],
            },
            {
                field: 'slaSolutionDate',
                headerName: 'SLA Data Solução',
                hide: true,
                width: this.columnsSize["slaSolutionDate"],
            },
            {
                field: 'slaDescription',
                headerName: 'SLA Descrição',
                hide: true,
                width: this.columnsSize["slaDescription"],
            },
            {
                field: 'workType',
                headerName: 'Tipo de Trabalho',
                hide: true,
                width: this.columnsSize["workType"],
            },
            {
                field: 'businessUnitDescription',
                headerName: 'Unidade de Negócio',
                hide: true,
                width: this.columnsSize["businessUnitDescription"],
            },
            // {
            //     field: 'lastCommentDate',
            //     headerName: 'Data Últ. Comentário',
            //     hide: true,
            //     width: this.columnsSize["lastCommentDate"],
            // },
        ];
        return colunas;
    }

    getColumnInfo(columnName: string) {

        var foundRecords = this.getAllAvaliableColumns().filter(v => v.field == columnName);

        if (foundRecords && foundRecords.length > 0) {
            foundRecords[0].hide = false;
            return foundRecords[0];
        }
        throw "";
    }

    getColumns(optionColumns: any) {
        var _columns = [...this.getAllAvaliableColumns()];

        _columns.map(item => {
            item.hide = optionColumns ? !optionColumns[item.field] : !this.optionColumnsDefault[item.field];
        });

        return _columns;
    }

    getColumnsCCC(optionColumns: any) {

        const colunas = [
            {
                field: 'checkbox',
                headerName: "",
                hide: false,
                width: this.columnsSize.checkbox,
            },
            {
                field: 'statusIcon',
                headerName: 'Ícone de Status de Solicitação',
                hide: !optionColumns["statusIcon"],
                width: this.columnsSize.statusIcon,
                height: '35px',
                overflow: "visible"
            },
            {
                field: 'id',
                headerName: 'N° Sol.',
                hide: !optionColumns["id"],
                width: this.columnsSize.id,
            },
            {
                field: 'idStatus',
                headerName: 'Status Solicitação',
                hide: !optionColumns["idStatus"],
                width: this.columnsSize.idStatus,
            },
            {
                field: 'workStatus',
                headerName: 'Status Trabalho',
                hide: !optionColumns["workStatus"],
                width: this.columnsSize.workStatus,
            },
            {
                field: 'sla_slo',
                headerName: 'SLA / SLO',
                hide: !optionColumns["sla_slo"],
                width: this.columnsSize.sla_slo,
            },
            {
                field: "subject",
                headerName: 'Assunto da Solicitação',
                hide: !optionColumns["subject"],
                width: this.columnsSize.subject,
            },
            {
                field: 'workName',
                headerName: 'Assunto do Trabalho',
                hide: !optionColumns["workName"],
                width: this.columnsSize.workName,
            },
            {
                field: "workGroupName",
                headerName: 'Equipe de Trabalho',
                hide: !optionColumns["workGroupName"],
                width: this.columnsSize.workGroupName,
            },
            {
                field: "nameResponsibleUser",
                headerName: 'Atendente',
                hide: !optionColumns["nameResponsibleUser"],
                width: this.columnsSize.nameResponsibleUser,
            },
            {
                field: 'nameUserRequester',
                headerName: 'Solicitante',
                hide: !optionColumns["nameUserRequester"],
                width: this.columnsSize.nameUserRequester,
            },
            {
                field: 'registrationDate',
                headerName: 'Data Sol.',
                hide: !optionColumns["registrationDate"],
                width: this.columnsSize.registrationDate,
            },
            {
                field: 'nameCustomer',
                headerName: 'Cliente',
                hide: !optionColumns["nameCustomer"],
                width: this.columnsSize.nameCustomer,
            },
            {
                field: "nameBusinessArea",
                headerName: 'Área de Negócio',
                hide: !optionColumns["nameBusinessArea"],
                width: this.columnsSize.nameBusinessArea,
            },
            {
                field: 'nameClassification',
                headerName: 'Classificação',
                hide: !optionColumns["nameClassification"],
                width: this.columnsSize.nameClassification,
            },
            {
                field: 'workDateBegin',
                headerName: 'Data Início Trab.',
                hide: !optionColumns["workDateBegin"],
                width: this.columnsSize.workDateBegin,
            },
            {
                field: 'workDateRegister',
                headerName: 'Data Registro Trab.',
                hide: !optionColumns["workDateRegister"],
                width: this.columnsSize.workDateRegister,
            },
            {
                field: 'endDate',
                headerName: 'Data Término Sol.',
                hide: !optionColumns["endDate"],
                width: this.columnsSize.endDate,
            },
            {
                field: 'workDateEnd',
                headerName: 'Data Término Trab.',
                hide: !optionColumns["workDateEnd"],
                width: this.columnsSize.workDateEnd,
            },
            {
                field: 'nameClassificationGroup',
                headerName: 'Grupo de Classificação',
                hide: !optionColumns["nameClassificationGroup"],
                width: this.columnsSize.nameClassificationGroup,
            },
            {
                field: 'nameServiceGroup',
                headerName: 'Grupo de Serviço',
                hide: !optionColumns["nameServiceGroup"],
                width: this.columnsSize.nameServiceGroup,
            },
            {
                field: 'nameOpenMode',
                headerName: 'Modo Abertura',
                hide: !optionColumns["nameOpenMode"],
                width: this.columnsSize.nameOpenMode,
            },
            {
                field: 'nameProcess',
                headerName: 'Processo',
                hide: !optionColumns["nameProcess"],
                width: this.columnsSize.nameProcess,
            },
            {
                field: 'nameService',
                headerName: 'Serviço',
                hide: !optionColumns["nameService"],
                width: this.columnsSize.nameService,
            },
            {
                field: 'slaResponseDate',
                headerName: 'Sla Data Resposta',
                hide: !optionColumns["slaResponseDate"],
                width: this.columnsSize.slaResponseDate,
            },
            {
                field: 'slaSolutionDate',
                headerName: 'Sla Data Solução',
                hide: !optionColumns["slaSolutionDate"],
                width: this.columnsSize.slaSolutionDate,
            },
            {
                field: 'slaDescription',
                headerName: 'SLA Descrição',
                hide: !optionColumns["slaDescription"],
                width: this.columnsSize.slaDescription,
            },
            {
                field: 'workType',
                headerName: 'Tipo de Trabalho',
                hide: !optionColumns["workType"],
                width: this.columnsSize.workType,
            },
            {
                field: 'businessUnitDescription',
                headerName: 'Unidade de Negócio',
                hide: !optionColumns["businessUnitDescription"],
                width: this.columnsSize.businessUnitDescription,
            },
            // {
            //     field: 'lastCommentDate',
            //     headerName: 'Data Últ. Comentário',
            //     hide: !optionColumns["lastCommentDate"],
            //     width: this.columnsSize.lastCommentDate,
            // },
        ];

        return colunas;
    }

    getColumnRenderCell(columnName: any) {
        var columnInfo = this.getColumnInfo(columnName);
        return this.getRenderCell(columnInfo)
    }

    getRenderCell(column: any) {
        var transColumns = {};
        var formatDateFunction = (date: Date) => {
            return (date != null) ? moment(date).format('DD/MM/YYYY') : "";
        }
        var formatDateTimeFunction = (date: Date) => {
            return (date != null) ? moment(date).format('DD/MM/YYYY HH:mm') : "";
        }

        switch (column.field) {
            case "statusIcon":
                column.renderColumn = (row: any) => {
                    const solicitationService = new SolicitationService(row);

                    let statusDescription = solicitationService.statusList.find(x => x.value === row.idStatus.toString())?.label;
                    statusDescription = (statusDescription) ? statusDescription : "";

                    const workStatus = solicitationService.workStatus.find(x => x.id === row.workStatus);

                    let workStatusDescription = (workStatus) ? workStatus.label : "";

                    if (statusDescription.endsWith("a") && statusDescription !== "Em pausa" && statusDescription !== "Aguardando outra área") {
                        statusDescription = statusDescription.substring(0, statusDescription.length - 1) + "o";
                    }

                    if (workStatusDescription.endsWith("a") && workStatusDescription !== "Em pausa" && workStatusDescription !== "Aguardando outra área") {
                        workStatusDescription = workStatusDescription.substring(0, workStatusDescription.length - 1) + "o";
                    }

                    return "Chamado:" + statusDescription + " Trabalho" + workStatusDescription;
                }
                column.renderCell = (row: any, type?: boolean) => {
                    const solicitationService = new SolicitationService(row);

                    const statusIcon = row.statusIcon;

                    let statusDescription = solicitationService.statusList.find(x => x.value === row.idStatus.toString())?.label;
                    statusDescription = (statusDescription) ? statusDescription : "";

                    const workStatus = solicitationService.workStatus.find(x => x.id === row.workStatus);

                    const workStatusIcon = (workStatus) ? workStatus.icon : "";
                    let workStatusDescription = (workStatus) ? workStatus.label : "";

                    if (statusDescription.endsWith("a") && statusDescription !== "Em pausa" && statusDescription !== "Aguardando outra área") {
                        statusDescription = statusDescription.substring(0, statusDescription.length - 1) + "o";
                    }

                    if (workStatusDescription.endsWith("a") && workStatusDescription !== "Em pausa" && workStatusDescription !== "Aguardando outra área") {
                        workStatusDescription = workStatusDescription.substring(0, workStatusDescription.length - 1) + "o";
                    }

                    return (
                        <LcTooltip
                            id={type ? '' : 'statusIcon'}
                            trigger={"hover"}
                            content={
                                <div style={
                                    {
                                        display: "flex",
                                        flexDirection: "column",
                                        flexWrap: "wrap",
                                        alignContent: "center",
                                        alignItems: "flex-start",
                                    }
                                }>
                                    <div style={
                                        {
                                            width: "auto",
                                            display: "flex",
                                            flexDirection: "row",
                                            flexWrap: "wrap",
                                            alignContent: "center",
                                            alignItems: "center",
                                        }
                                    }>
                                        <LcIcon icon={statusIcon} color='grey' />
                                        <span style={{ color: "#2B304F", fontSize: "14px" }}>Chamado <b>{statusDescription.toLowerCase()}</b></span>
                                    </div>

                                    <div style={
                                        {
                                            width: "auto",
                                            display: "flex",
                                            flexDirection: "row",
                                            flexWrap: "wrap",
                                            alignContent: "center",
                                            alignItems: "center",
                                        }
                                    }>
                                        <LcIcon icon={workStatusIcon} color='grey' />
                                        <span style={{ color: "#2B304F", fontSize: "14px" }}>Trabalho <b>{workStatusDescription.toLowerCase()}</b></span>
                                    </div>
                                </div>
                            }
                            position={"right"}
                            maxWidth={"500px"}
                            border={"1px solid #B2B2B2"}
                            children={<LcIcon icon={row.statusIcon} color='grey' />}
                        />
                    )
                }

                break;

            case "idStatus":
                column.renderColumn = (row: any) => {
                    const solicitationService = new SolicitationService(row);

                    let statusDescription = solicitationService.statusList.find(x => x.value === row.idStatus.toString())?.label;
                    statusDescription = (statusDescription) ? statusDescription : "";

                    return statusDescription;
                }
                column.renderCell = (row: any) => {
                    return <StatusColorDisplay row={row} type={"solicitation"} />
                }
                break;

            case "workStatus":
                column.renderColumn = (row: any) => {
                    const solicitationService = new SolicitationService(row);

                    let statusDescription = (row.workStatus) ? solicitationService.statusList.find(x => x.value === row.workStatus.toString())?.label : "";
                    statusDescription = (statusDescription) ? statusDescription : "";

                    return statusDescription;
                }
                column.renderCell = (row: any) => {
                    return <StatusColorDisplay row={row} type={"work"} />
                }

                break;

            case "nameResponsibleUser":
                column.renderCell = (row: any) => {
                    const maxWidthCampo = (parseInt(this.columnsSize["nameResponsibleUser"]) - 20) + "px";
                    return (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <RequesterDisplay row={row} />
                        </div>

                    )
                }

                break;

            case "nameUserRequester":
                const maxWidthCampo = (parseInt(this.columnsSize["nameUserRequester"]) - 20) + "px";

                column.renderCell = (row: any) => (
                    <span style={{ maxWidth: maxWidthCampo, wordWrap: "normal" }}> {row.nameUserRequester} </span>
                )

                break;

            case "workDateBegin":
                column.renderColumn = (row: any) => {
                    return formatDateFunction(row.workDateBegin);
                }
                column.renderCell = (row: any) => {
                    return <span> {column.renderColumn(row)} </span>
                }

                break;

            case "workDateRegister":
                column.renderColumn = (row: any) => {
                    return formatDateFunction(row.workDateRegister);;
                }
                column.renderCell = (row: any) => {
                    return <span> {column.renderColumn(row)} </span>
                }

                break;

            case "registrationDate":
                column.renderColumn = (row: any) => {
                    return formatDateFunction(row.registrationDate);
                }
                column.renderCell = (row: any) => {
                    return <span> {column.renderColumn(row)} </span>
                }

                break;

            case "endDate":
                column.renderColumn = (row: any) => {
                    return formatDateFunction(row.endDate);
                }
                column.renderCell = (row: any) => {
                    return <span> {column.renderColumn(row)} </span>
                }

                break;

            case "workDateEnd":
                column.renderColumn = (row: any) => {
                    return formatDateFunction(row.workDateEnd);
                }
                column.renderCell = (row: any) => {
                    return <span> {column.renderColumn(row)} </span>
                }

                break;

            case "slaResponseDate":
                column.renderColumn = (row: any) => {
                    return formatDateFunction(row.slaResponseDate);
                }
                column.renderCell = (row: any) => {
                    return <span> {column.renderColumn(row)} </span>
                }

                break;

            case "subject":
                column.renderCell = (row: any) => {
                    return <span style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", display: "block" }}>{row.subject}</span>
                }

                break;

            case "slaSolutionDate":
                column.renderColumn = (row: any) => {
                    return formatDateFunction(row.slaSolutionDate);
                }
                column.renderCell = (row: any) => {
                    return <span> {column.renderColumn(row)} </span>
                }

                break;

            case "sla_slo":
                column.renderColumn = (row: any) => {
                    return `SLA: ${row.slaPercentual}% / SLO: ${row.sloPercentual}%  `;
                }
                column.renderCell = (row: any) => {
                    return <AttendanceSlaSloBar solicitation={row} width={"100px"} height={"4px"} />
                }

                break;

            case "lastCommentDate":
                column.renderColumn = (row: any) => {
                    return formatDateTimeFunction(row.lastCommentDate);
                }
                column.renderCell = (row: any) => {
                    return <span> {column.renderColumn(row)} </span>
                }

                break;

            //  case "checkbox":
            //     let rows: any[] = []
            //     // column.renderColumn = () => {
            //     //     return "";
            //     // }
            //     column.renderCell = (row: any) => {
            //         let isOnSelectedRowsRadio = rows ? rows.find((r: any) => { return r.id === row.id }) : undefined;

            //         return (
            //             <div className="radioCheck">
            //                 <div
            //                     className="selectable"
            //                     onClick={() => {
            //                         let newRow: any[] = [];
            //                         if (isOnSelectedRowsRadio) {
            //                             rows.filter((r: any) => {
            //                                 if (r.id !== row.id) newRow.push(r)
            //                             });
            //                             rows = newRow
            //                         }
            //                         else {
            //                             rows.push(row)
            //                         }
            //                     }}
            //                     style={{ marginRight: "5px", marginLeft: "5px" }}
            //                 >
            //                     <i className={`ppi ppi-radiobtn${isOnSelectedRowsRadio ? '-on ' : ' '}`} />
            //                 </div>
            //             </div>
            //         )
            //     }
            // break;
            default:
                column.renderCell = (row: any) => {
                    const data = (row[column.field]);
                    return <span> {data} </span>;
                }

                break;
        }

        return column;
    }

    GroupListKey(groupList_: any[], lista: any[]) {
        let listaGruposKey_: { key: string, content: any[] }[] = [];

        groupList_.map(group => {
            let listaTemp: string[] = [];

            lista.map(row => {

                if (!listaTemp.includes(row[group])) {
                    if (row[group] == null) {
                        if (!listaTemp.includes("")) {
                            listaTemp.push("");
                        }
                    }
                    else {
                        listaTemp.push(row[group]);
                    }
                }
            });

            listaTemp = listaTemp.sort((a: any, b: any) => {

                return (a > b) ? 1 : -1;
            })

            listaGruposKey_.push({ key: group, content: listaTemp });
        });

        return listaGruposKey_;
    }

    groupListAggregator(lista: any[], listaGruposKey_: any[]) {
        let filteredList_: any[] = [];
        let listaTemp: any[] = lista;
        let count = 0;

        listaGruposKey_.map(grupoItem => {
            let listNivel: any[] = [];

            if (listaTemp[0] instanceof Array) {
                listaTemp[0].map(row => {
                    if (row instanceof Array) {
                        listNivel.push(this.aggregator(grupoItem, row));
                    }
                });
            }
            else {
                listNivel.push(this.aggregator(grupoItem, listaTemp));
            }

            filteredList_.push(listNivel);

            if (count === 0) {
                listaTemp = filteredList_[count];
            }
            else {
                listaTemp = [];
                listaTemp.push(filteredList_[count]);
            }

            count++;
        });

        return listaTemp;
    }

    aggregator(grupoItem: any, listaRows: any[]) {
        let listaGrupo_: any[] = [];
        let listaTemp: any[] | undefined = [];

        if (listaRows[0] instanceof Array) {
            listaRows.map(rows => {
                listaTemp = this.aggregator(grupoItem, rows);

                if (listaTemp && listaTemp.length > 0) {
                    listaGrupo_.push(listaTemp);
                }
            })
        }
        else {
            grupoItem.content.map((item: string) => {
                if (item == "") {
                    listaTemp = listaRows.filter(x => x[grupoItem.key] == null);
                }
                else {
                    listaTemp = listaRows.filter(x => x[grupoItem.key] == item);
                }

                if (listaTemp && listaTemp.length > 0) {
                    listaGrupo_.push(listaTemp);
                }
            });
        }

        if (listaGrupo_.length > 0) {
            return listaGrupo_;
        }
    }

    sortColumns(listaRows: any[] | SolicitationView[], filter: any): any {
        let listaTemp: SolicitationView[] | undefined = [];
        let listaAlinhada: any[] = [];

        if (listaRows[0] instanceof Array) {
            listaRows.map(rows => {

                listaTemp = this.sortColumns(rows, filter);

                if (listaTemp && listaTemp.length > 0) {
                    listaAlinhada.push(listaTemp);
                }
            });
        }
        else {
            listaTemp = listaRows.sort((a: any, b: any) => {
                if (filter.direction === 'asc') {
                    return (a[filter.column] > b[filter.column]) ? 1 : -1;
                }
                else {
                    return (a[filter.column] > b[filter.column]) ? -1 : 1;
                }
            });

            if (listaTemp && listaTemp.length > 0) {
                listaAlinhada = listaTemp;
            }
        }

        if (listaAlinhada.length > 0) {
            return listaAlinhada;
        }
    }

    findSolicitationNextPreviousInGroup(listaRows: any, solicitationWorkId: number, type: string) {
        let item: any;

        if (listaRows[0] instanceof Array) {
            for (let index = 0; index < listaRows.length; index++) {
                item = this.findSolicitationNextPreviousInGroup(listaRows[index], solicitationWorkId, type);

                if (item != 0) break;
            }
        }
        else {
            let index = listaRows.findIndex(x => x.idWork === solicitationWorkId);

            if (index >= 0) {
                item = (type === "next")
                    ? listaRows[index + 1]
                    : listaRows[index - 1];
            }
            else {
                item = 0;
            }
        }

        return item;
    }

    getGroup(row: any, grupoGeral: string) {
        const solicitationService = new SolicitationService(row);
        let grupo = "";

        if (row instanceof Array) {

            grupo = this.getGroup(row[0], grupoGeral);

            if (grupo === undefined) {
                grupo = "(SEM REGISTRO)";
            }
        }
        else {
            if (row[grupoGeral] == "" || row[grupoGeral] == null) {
                if (grupoGeral == "nameResponsibleUser") {
                    grupo = "(SEM ATENDENTE)";
                }
                else if (grupoGeral == "workGroupName") {
                    grupo = "(SEM GRUPO)";
                }
                else {
                    grupo = "(SEM REGISTRO)";
                }
            }
            else {
                if (grupoGeral == "workStatus" || grupoGeral == "idStatus") {
                    let status = solicitationService.statusList.find(x => x.value === row[grupoGeral].toString());
                    grupo = (status) ? status.label : "";
                }
                else if (grupoGeral == "urgency") {
                    let urgency = solicitationService.urgency.find(x => x.id === row[grupoGeral]);
                    grupo = (urgency) ? urgency.label : "";
                }
                else if (grupoGeral.includes("date") || grupoGeral.includes("Date")) {
                    grupo = moment(row[grupoGeral]).format('DD/MM/YYYY');
                }
                else {
                    grupo = row[grupoGeral];
                }
            }
        }

        return grupo.toString().toUpperCase();
    }

}